export const getHostnameFromUrl = (url: string | null | undefined): string | null => {
  if (url == null || url === '') {
    return null;
  }

  try {
    const hostname = new URL(url).hostname;
    return hostname.replace(/^www\./, '');
  } catch {
    return null;
  }
};

export const mapFolderCollectionToSection = (collection: string): string => {
  switch (collection) {
    case 'links_sales_material':
      return 'unterlagen';
    case 'links_conditions':
      return 'bedingungen';
    case 'links_additional':
      return 'weiterfuehrend';
    default:
      return 'unknown';
  }
};

export const mapSidebarSectionTitleToKey = (title: string): string => {
  switch (title) {
    case 'Bedingungen':
      return 'bedingungen';
    case 'Unterlagen':
      return 'unterlagen';
    case 'Weiterführende Links':
      return 'weiterfuehrend';
    default:
      return 'unknown';
  }
};
